const labels = {
  All: { 'See the offering': 'Lihat persembahannya' },
  FacilityDetails: { 'Ref: Page title': 'Detail Fasilitas', 'Ref: Review': 'Tinjauan' },
  FacilitiesList: { 'Ref: Page title': 'Fasilitas', 'Ref: See details': 'Lihat detailnya' },
};
export default labels;
